/**
 * LINE Short URL API Service
 */
import apiClient from '../axios.js';

export default {
  /**
   * 查詢短網址列表
   * @param {Object} params - 查詢參數
   * @returns {Promise}
   */
  async list(params = {}) {
    const response = await apiClient.get('/line/short-url', { params });
    return response;
  },

  /**
   * 查詢短網址詳情
   * @param {string} id - 短網址 ID
   * @returns {Promise}
   */
  async get(id) {
    const response = await apiClient.get(`/line/short-url/${id}`);
    return response;
  },

  /**
   * 建立短網址
   * @param {Object} data - 短網址資料
   * @returns {Promise}
   */
  async create(data) {
    const response = await apiClient.post('/line/short-url', data);
    return response;
  },

  /**
   * 更新短網址
   * @param {string} id - 短網址 ID
   * @param {Object} data - 更新資料
   * @returns {Promise}
   */
  async update(id, data) {
    const response = await apiClient.put(`/line/short-url/${id}`, data);
    return response;
  },

  /**
   * 刪除短網址
   * @param {string} id - 短網址 ID
   * @returns {Promise}
   */
  async delete(id) {
    const response = await apiClient.delete(`/line/short-url/${id}`);
    return response;
  },

  /**
   * 查詢點擊記錄
   * @param {string} id - 短網址 ID
   * @param {Object} params - 查詢參數
   * @returns {Promise}
   */
  async getClicks(id, params = {}) {
    const response = await apiClient.get(`/line/short-url/${id}/clicks`, { params });
    return response;
  },

  /**
   * 查詢統計資訊
   * @param {string} id - 短網址 ID
   * @returns {Promise}
   */
  async getStatistics(id) {
    const response = await apiClient.get(`/line/short-url/${id}/statistics`);
    return response;
  }
};
